import { Card } from "@/shared/ui/card.tsx";
import { Image } from "lucide-react";
import verifiedIcon from '../../../../public/verified.svg'
import { useAtomValue } from "jotai";
import { themeAtom } from "@/features/app-layout/atoms/theme-atoms";

type GeneratedPostCardProps = {
  cta: string,
  date_of_posting: string,
  hashtags: string[],
  image_video_recommendations: string,
  platform: string,
  text: string,
  time_of_posting: string,
}
const GeneratedPostCard = ({ cta, date_of_posting, hashtags, image_video_recommendations, text, time_of_posting, platform }: GeneratedPostCardProps) => {

  const theme = useAtomValue(themeAtom)

  return (
    <Card className="w-full p-5 flex flex-col justify-evently gap-1 relative">
      <div className="absolute top-4 right-4 flex items-center gap-2">
        <img src={`https://cdn.simpleicons.org/${(platform.toLowerCase().includes("twitter")) ? "x" : platform.toLowerCase()}`} className=" w-6 h-6" />
      </div>
      <div className="flex items-center gap-2">
        <img src={theme.avatar} className="w-8 aspect-square rounded-full" />
        <div className="flex flex-col">
          <p className="text-sm flex items-center gap-1 font-semibold">{theme.company}
            <img src={verifiedIcon} alt="" className="w-4" />
          </p>
          <p className="text-xs text-gray-600">@{theme.handle}</p>
        </div>
      </div>
      <h3 className="text-lg font-[500]">{cta}</h3>
      <p className="text-sm">{text}</p>
      <span className="flex items-center gap-1 flex-wrap text-sm">
        {hashtags.map(tag => (
        <p key={tag}>{tag}</p>
        ))}
      </span>
      <span className="flex items-center gap-1 text-sm">
        <p>{date_of_posting}</p>
        <p>|</p>
        <p>{time_of_posting}</p>
      </span>
      <div className="flex flex-col items-start gap-0 my-2 justify-start">
        <span className="flex items-center gap-2">
          <Image size={14} />
          <p>Image recommendations</p>
        </span>
        <p className="text-xs">
          {image_video_recommendations}
        </p>
      </div>
    </Card>
  )
}

export default GeneratedPostCard;
